import React from 'react';
import { ActionCreators } from 'redux-undo';
import { connect } from 'react-redux';
import FormFieldNumberInput from './FormFieldNumberInput';
import UndoButton from './UndoButton';

class SelectQuantity extends React.Component {

  submitConstraint() {
    this.props.commitConstraint();
  }

  undo() {
    this.props.dispatch(ActionCreators.undo());
  }

  render() {
    const formfieldmap = this.props.formFields.map(formfield =>
      <FormFieldNumberInput
        price={this.props.price}
        changeAmount={this.props.changeAmount}
        increaseAmount={this.props.increaseAmount}
        decreaseAmount={this.props.decreaseAmount}
        key={formfield.id}
        data={formfield}
      />);

    return (
      <div id="SelectQuantity">
        <p>{this.props.description}</p>
        {(this.props.error) ? <div className="alert alert-warning">{this.props.error}</div> : ''}
        <table className="table">
          <thead>
            <tr>
              <th>Option</th>
              <th className="text-right">Preis</th>
              <th className="text-right">Anzahl</th>
            </tr>
          </thead>
          <tbody>
            {formfieldmap}
          </tbody>
        </table>
        <div className="row">
          <div className="col-xs-4">
            <UndoButton undoAvailable={this.props.undoAvailable} />
          </div>
          <div className="col-xs-8">
            <button
              className="btn-block btn btn-success"
              onClick={this.submitConstraint.bind(this)}
            >
              weiter
            </button>
          </div>
        </div>
      </div>
    );
  }
}


export default connect()(SelectQuantity);
